
export class Corner {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Corner"
    this.scene = "Corner";
    this.data = [];
    this.page = 70;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {

      const corners = options?.player?.corner;

      
      xml.payload.field.find((item) => {
        return item.attr.name === "100";
      }).value = (options?.player?.last_name.toUpperCase() || "") + "'S CORNER";

      xml.payload.field.find((item) => {
        return item.attr.name === "101";
      }).value = (corners?.[0]?.corner.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = (corners?.[1]?.corner.toUpperCase() || "");

      
      xml.payload.field.find((item) => {
        return item.attr.name === "104";
      }).value = (corners?.[2]?.corner.toUpperCase() || "");

      
      xml.payload.field.find((item) => {
        return item.attr.name === "105";
      }).value = (corners?.[3]?.corner.toUpperCase() || "");

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
